<div class="crop-image-button">
    <img src="{{globalDatalistService.IMGAE_PATH}}/crop_icon.png" (click)="upload()" title="Crop image" />
    <img src="{{globalDatalistService.IMGAE_PATH}}/close.png" (click)="close()"  title="Cancel"/>
</div>
<image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="width / height"
    format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"></image-cropper>

<!-- <img [src]="croppedImage" /> -->